import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  Input,
  OnChanges,
  OnInit, Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Position } from '../../../utils/positioning';

@Component({
  selector: 'kz-tutorial-popup',
  template: `
    <div class="kz-helper">
      <span #kzHelperOverlay class="kz-helper-overlay"></span>
      <div #kzHelperPopin [class]="popinClasses">
        <h2 class="kz-helper--title small" *ngIf="title" [innerText]="title"></h2>
        <p class="kz-helper--description" *ngIf="description" [innerText]="description"></p>
        <ng-content></ng-content>
        <div class="kz-helper--controls">
          <kz-field class="kz-helper--doNotShot" absErrorMsg="true" (click)="hide.emit()" >
            <input kzCheckBox type="checkbox" id="kz-helper--doNotShot" name="kz-helper--doNotShot"/>
            <label kzLabel for="kz-helper--doNotShot" i18n="@@kaza.tutorial.dontshow">Don’t show again</label>
          </kz-field>
          <span class="kz-helper--slide"><span class="kz-helper--count">{{itemOrder}}</span> / <span class="kz-helper--total">{{totalItems}}</span></span>
          <div class="kz-helper--buttons">
            <button (click)="previous.emit()" *ngIf="itemOrder > 1" type="button" class="kz-helper--buttons-prev kz-button kz-button--medium kz-button--secondary"><span>&lt;</span></button>
            <button #actionNext (click)="next.emit()" *ngIf="itemOrder < totalItems" type="button" class="kz-helper--buttons-next kz-button kz-button--medium kz-button--flat"><span i18n="@@kaza.tutorial.next">Next</span></button>
            <button #actionEnd (click)="hide.emit()" *ngIf="itemOrder == totalItems" type="button" class="kz-helper--buttons-end kz-button kz-button--medium kz-button--flat"><span i18n="@@kaza.tutorial.end">Finish</span></button>
            <button (click)="closed.emit()" type="button" class="kz-helper--buttons-close">&times;</button>
          </div>
        </div>

      </div>
    </div>`,
  styleUrls: ['./kz-tutorial.component.scss'],
  host: {
    '[class]': '"kz-tutorial" + (classes ? " " + classes : "")',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class KzTutorialComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('kzHelperOverlay', {read: ElementRef, static: true}) kzHelperOverlay: ElementRef;
  @ViewChild('kzHelperPopin', {read: ElementRef, static: true}) kzHelperPopin: ElementRef;
  @ViewChild('actionNext', {read: ElementRef, static: false}) actionNextElement: ElementRef;
  @ViewChild('actionEnd', {read: ElementRef, static: false}) actionEndElement: ElementRef;

  private _classes: string;

  get classes(): string {
    return this._classes;
  }

  private _popinClasses = 'kz-helper-popin';

  get popinClasses(): string {
    return this._popinClasses;
  }

  private _tutorialPosition: Position;

  get tutorialPosition(): Position {
    return this._tutorialPosition;
  }

  @Input()
  set tutorialPosition(position: Position) {
    this._tutorialPosition = position;
  }

  private _tutorialPopupOrder = 0;
  private _tutorialPopupTotalItems = 0;

  @Input()
  set itemOrder(order: number) {
    this._tutorialPopupOrder = order;
  }
  get itemOrder(): number {
    return this._tutorialPopupOrder;
  }

  @Input()
  set totalItems(total: number) {
    this._tutorialPopupTotalItems = total;
  }
  get totalItems(): number {
    return this._tutorialPopupTotalItems;
  }

  @Input() title: string;
  @Input() description: string;

  @Output()
  readonly closed: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  readonly next: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  readonly previous: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  readonly hide: EventEmitter<void> = new EventEmitter<void>();

  constructor(
      private el: ElementRef,
      private _changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    if (this.actionNextElement) {
      this.actionNextElement.nativeElement.focus();
    }
    if (this.actionEndElement) {
      this.actionEndElement.nativeElement.focus();
    }
  }

  private _updateClasses() {
    this._classes = '';

    if (this.tutorialPosition) {
      this._popinClasses += ` kz-helper-popin--${ this.tutorialPosition.startsWith('left') ? 'right' : 'left' }`;
    } else {
      this._classes += ` kz-helper-popin--no-selector`;
    }
    if (this._tutorialPopupOrder === 1) {
      this._popinClasses += ` kz-helper-popin--first`;
    }
    if (this._tutorialPopupOrder === this._tutorialPopupTotalItems) {
      this._popinClasses += ` kz-helper-popin--last`;
    }
  }

}
